import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import {useLang} from '../../context/LanguageContext';
import {useAuth} from "../../context/AuthContext";
import DateUtils from "../../utils/dateUtils";
import Footer from "../../components/Footer";

const GeneratedTicketPage = () => {
  const navigate = useNavigate();
  const { t, getBetTranslation } = useLang()
  const { hasPaid } = useAuth();
  const [generatedGames, setGeneratedGames] = useState([]);
  const [totalOdd, setTotalOdd] = useState(0);

  useEffect(() => {
    // read from localStorage
    const stored = localStorage.getItem('generatedGames');
    if (stored) {
      const parsed = JSON.parse(stored);
      setGeneratedGames(parsed);

      // calculate the product of all odds
      let product = 1;
      parsed.forEach((g) => {
        const numOdd = parseFloat(g.odd);
        if (!isNaN(numOdd)) {
          product *= numOdd;
        }
      });
      setTotalOdd(product);
    } else {
      // no data => navigate back or show an error
      console.error('No generated games found');
      navigate(-1);
    }
  }, [navigate]);

  return (
    <div className="bg-[#34495e] min-h-screen p-5 relative">
      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
      >
        <FaArrowLeft />
        <span className="text-white">{t('btn.back')}</span>
      </button>

      <h1 className="text-xl text-white font-bold text-center mt-16 mb-8">
        {t('txt.generatedTicketTitle')}
      </h1>

      <div className="mb-4 text-center">
        <p className="font-semibold text-white">
          {t('txt.totalOdds')}: {totalOdd.toFixed(2)}
        </p>
      </div>

      <div className="space-y-4">
        {generatedGames.map((game) => {
          const translatedDay = DateUtils.formatDayOnly(game.day, t);

          const translatedMarketName = getBetTranslation(game.marketName);
          const translatedMarket = getBetTranslation(game.market);

          return (
            <div key={game.id} className="bg-white shadow rounded p-4">
              {hasPaid ? (
                <div>
                  <p className="font-bold text-sm">
                    {game.team1} vs {game.team2}
                  </p>
                  <p className="text-xs text-gray-500">
                    {translatedDay} {game.hour}
                  </p>
                  <p className="mt-1 text-sm">
                    {translatedMarketName} ({translatedMarket}) -{' '}
                    <span className="font-semibold text-green-600">
                      {game.odd}
                    </span>
                  </p>
                </div>
              ) : (
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-bold text-sm">
                      {game.team1} vs {game.team2}
                    </p>
                    <p className="text-xs text-gray-500">
                      {translatedDay} {game.hour}
                    </p>
                  </div>
                  <button 
                    onClick={() => navigate('/account')}
                    className="bg-orange-500 text-white px-3 py-1 rounded"
                  >
                    Unlock
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
        <Footer />
    </div>
  );
};

export default GeneratedTicketPage;
